.product-suggestion {
  display: flex;
}
.product-suggestion .image {
  width: 120px;
  height: 120px;
  margin-right: 10px;
  background-size: contain;
  background-repeat: no-repeat;
  border: solid 1px #eee;
}
.product-suggestion .content {
  width: 500px;
}
.product-suggestion .content .product-header {
  min-height: 90px;
}
.product-suggestion .content .input {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
.product-suggestion .content .input .btn-info {
  height: 29px;
}

@media screen and (max-width: 500px) {
  .product-suggestion {
    margin-bottom: 40px;
  }
  .product-suggestion .image {
    width: 60px;
    height: 60px;
    margin-right: 10px;
    background-size: contain;
    background-repeat: no-repeat;
    border: solid 1px #eee;
  }
  .product-suggestion .content {
    width: 100%;
  }
  .product-suggestion .content .input .btn-info {
    height: 25px;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */